"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemsList = void 0;
const react_1 = __importStar(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const Button_1 = __importDefault(require("@mui/material/Button"));
const ChevronLeft_1 = __importDefault(require("@mui/icons-material/ChevronLeft"));
const ListItem_1 = __importDefault(require("./ListItem"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const BackButtonWrapper = styled_components_1.default.div `
  display: ${(props) => (props.showBackButton ? 'block' : 'none')};
  cursor: pointer;
  margin-bottom: 24px;
  color: black;
`;
const TreeStructureWrapper = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  padding: 16px;
  overflow: auto;
  background-color: ${props => props.theme.palette.dsInteractiveBackground};

  @media (min-width: 840px) {
    padding: 24px;
  }
`;
const ListWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 2vmin;
  margin: 0 16px 0px;

  @media (min-width: 600px) {
    margin: 0 32px 0px;
  }

  @media (min-width: 1240px) {
    margin: 0 200px 0px;
  }
`;
const ItemsList = ({ collection, updateStore }) => {
    const [collectionStack, setCollectionStack] = (0, react_1.useState)([collection]);
    (0, react_1.useEffect)(() => {
        setCollectionStack([collection]);
    }, [collection]);
    const onFolderClick = (folderData) => {
        setCollectionStack([folderData.children, ...collectionStack]);
    };
    const handleOpenDialog = (content) => {
        updateStore('isDialogOpen', true);
        updateStore('dialogContent', content);
    };
    const goBack = () => {
        setCollectionStack(collectionStack.splice(1));
    };
    const renderTreeStructure = () => {
        const tree = [];
        if (collectionStack[0]) {
            collectionStack[0].map((node) => {
                const nodeType = Object.keys(node)[0];
                const currentNode = node.folder || node[nodeType];
                const onClickFunction = nodeType === 'folder' ? onFolderClick : handleOpenDialog;
                tree.push(react_1.default.createElement(ListItem_1.default, { onListItemClick: onClickFunction, content: currentNode, key: (0, react_uid_1.uid)(currentNode) }));
                return node;
            });
        }
        return tree;
    };
    return (react_1.default.createElement(TreeStructureWrapper, null,
        react_1.default.createElement(BackButtonWrapper, { onClick: goBack, showBackButton: collectionStack.length > 1 },
            react_1.default.createElement(Button_1.default, { color: "inherit", startIcon: react_1.default.createElement(ChevronLeft_1.default, null) }, i18n_js_1.default.t('dictionary.back'))),
        react_1.default.createElement(ListWrapper, null, renderTreeStructure())));
};
exports.ItemsList = ItemsList;
const mapStoreToProps = () => ({});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.ItemsList);
